import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { getViewApplicationCohort } from "../../AdminDashboard/ViewApplication/dependencies/action";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import * as moment from "moment";
import SubmitAction from "../../../SubmitAction";
import swal from "sweetalert";
import api from "../../../../common/dependencies/utils/Api";
import hashImage from "../../../../../assets/images/hashImage.jpeg";
import {
  SET_ADMIN_COHORT_STATUS,
  GET_SIGNAL_MENTOR_DATA,
} from "../../../../common/constants/ApplicationUrl";
import * as CryptoJS from "crypto-js";
import { PROFILE_KEY } from "../../../../common/constants/actionConstants";
const ViewApplicationCohort = (props) => {
  class AesUtil {
    constructor(keySize, iterationCount) {
      this.keySize = keySize / 32;
      this.iterationCount = iterationCount;
    }
  
    generateKey = function (salt, passPhrase) {
      let key = CryptoJS.PBKDF2(passPhrase, CryptoJS.enc.Hex.parse(salt), {
        keySize: this.keySize,
        iterations: this.iterationCount,
      });
      return key;
    };
  
    encrypt = function (salt, iv, passPhrase, plainText) {
      let key = this.generateKey(salt, passPhrase);
      let encrypted = CryptoJS.AES.encrypt(plainText, key, {
        iv: CryptoJS.enc.Hex.parse(iv),
      });
      return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
    };
  }
  const encryptAES2 = (text, key) => {
    // let iv = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
    // let salt = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
  
    // let aesUtil = new AesUtil(128, 1000);
    // let ciphertext = aesUtil.encrypt(salt, iv, key, text);
  
    // let aesText = iv + "::" + salt + "::" + ciphertext;
    
    return btoa(text);
  };
  let newNameArray = [];
  const defaultFormData = {
    enrolementIdsnew: newNameArray,
  };
  const [formData, setFormData] = useState(defaultFormData);

  const { applicationData, getViewApplicationCohort } = props;

  const [students, setStudents] = useState([]);
  const [selectedColor, setSelectedColor] = useState(false);
  const [selectedColor2, setSelectedColor2] = useState(false);
  const [selectedColor3, setSelectedColor3] = useState(false);
  const [mentorentrolmentid, setMentorentrolmentid] = useState([]);
  const [showSubmitAction, setShowSubmitAction] = useState(false);
  const [action, setAction] = useState();
  const [appArrayMap, setAppArrayMap] = useState();
  const [submitData, setSubmitData] = useState();
  //  let valuelogin = localStorage.getItem("SavedLoggedInData");
  const value = JSON.parse(localStorage.getItem("SavedLoggedInData"));
  const getApplicationId = (string) => {
    const value = string.substring(string.length - 6);
    return value;
  };
  const getCohortId = (cohort) => {
    const value = cohort.slice(cohort.length - 6);
    return value;
  };
  const getmentorenrolemtId = (mentorid) => {
    let array = [];
    applicationData?.data?.mentorenrolmentid.map((data, key) => {
      // const value = "M" + data.slice(data.length - 6);
      const value = data;
      setMentorentrolmentid([...data, value]);
      array.push(value);
    });
    return array;
  };
  const onclickShowSubmitAction = (action, id, status) => {
    setShowSubmitAction(true);
    setAction(action);
    let params = {
      id: id,
      status: status,
    };
    setSubmitData(params);
  };
  const clickOnClose = (data) => {
    // alert(data)
    setShowSubmitAction((x) => !x);
  };
  useEffect(() => {
    let params;
    if (window.id != undefined && window.id != null && window.id != "") {
      params = { id: window.id };
    } else {
      let applnId = window.location.pathname.split("/");

      params = { id: applnId[applnId.length - 1] };
    }
    getViewApplicationCohort(params);
  }, []);

  useEffect(() => {
    // applicationData &&
    //   applicationData?.data?.mentorenrolmentid.map((item) => {
    //     const params = {
    //       email_id: item,
    //     };
    //     api
    //       .POST(`${GET_SIGNAL_MENTOR_DATA}`, params)
    //       .then((response) => {
    //         const { data, status } = response || {};
    //         if (status === 200) {
    //

    //           const newObject = {
    //             id: data?.data?.id,
    //             name: data?.data?.applicant_name,
    //           };
    //           newNameArray.push(newObject);
    //           setAppArrayMap(newNameArray);
    //         } else {
    //           // return { status: false }
    //         }
    //       })
    //       .catch((e) => {
    //         // return Promise.reject(e);
    //       });
    //   });
    const value = [
      {
        question: "Cohort ID",
        answser:
          applicationData &&
          applicationData?.data?.cohortId &&
          getCohortId(applicationData?.data?.cohortId),
      },
      {
        question: "Name of Mentor",
        answser: applicationData && applicationData?.data?.mentor_name,
      },
      {
        question: "Name of Organization",
        answser: applicationData && applicationData?.data?.organization_name,
      },
      {
        question: "Type of Organization",
        answser: applicationData && applicationData?.data?.organization_type,
      },
      {
        question: "Name of The Program",
        answser: applicationData && applicationData?.data?.program_name,
      },

      {
        question: "Decription of Program",
        answser: applicationData && applicationData?.data?.program_desc,
      },
      {
        question: "Banner",
        answser: applicationData && applicationData?.data?.uploadBanner,
      },
      {
        question: "Duration of The Program",
        answser: applicationData && applicationData?.data?.infiniteDuration ? "No end date" : applicationData && applicationData?.data?.program_duration+" "+"months",
      },
      // {
      //   question: "Program Continuity",
      //   answser: applicationData && applicationData?.data?.infiniteDuration ? "Infinite Duration" : "Limited Duration",
      // },
      {
        question: "Cohort Start Date",
        answser:
          applicationData?.data?.applicationStatus != "DRAFT" &&
          applicationData?.data?.date_applied != null &&
          applicationData &&
          moment(applicationData?.data?.date_applied).format("DD/MM/YYYY"),
      },
      {
        question: "Startup Application Start Date",
        answser:
          applicationData?.data?.applicationStatus != "DRAFT" &&
          applicationData?.data?.startup_start_date != null &&
          applicationData &&
          moment(applicationData?.data?.startup_start_date).format(
            "DD/MM/YYYY"
          ),
      },
      {
        question: "Startup Application End Date",
        answser:
          applicationData?.data?.applicationStatus != "DRAFT" &&
          applicationData?.data?.startup_end_date != null &&
          applicationData &&
          moment(applicationData?.data?.startup_end_date).format("DD/MM/YYYY"),
      },
      // {
      //   question: "Average Mentorship Hours Per Week to be spent",
      //   answser: applicationData && applicationData?.data?.hoursperweek,
      // },
      // {
      //   question: "Number of Mentors",
      //   answser: applicationData && applicationData?.data?.numberofmentors,
      // },
      // {
      //   question: "Mentor Enrolment IDs",
      //   answser:
      //     applicationData &&
      //     applicationData?.data?.mentorenrolmentid &&
      //     getmentorenrolemtId(applicationData?.data?.mentorenrolmentid),
      // },

      // {
      //   question: "Upload List of Mentors",
      //   answser: applicationData && applicationData?.data?.uploadAttach,
      // },
      // {
      //   question: "Number of startups for each mentor",
      //   answser: applicationData && applicationData?.data?.numberofstartups,
      // },
      {
        question: "Industry / Sector",
        answser: applicationData && applicationData?.data?.industry,
      },
      {
        question: "Specialization / Function",
        answser: applicationData && applicationData?.data?.specialization,
      },
      {
        question: "Preferred stage of the startup",
        answser: applicationData && applicationData?.data?.preferred_stage,
      },
      {
        question: "Cohort Type",
        answser: applicationData && applicationData?.data?.cohortVisibility ? "Public" : "Private",
      },
    ];

    // applicationData &&
    //   applicationData?.data?.mentorenrolmentid.map((item) => {
    //     const params = {
    //       email_id: item,
    //     };
    //     api
    //       .POST(`${GET_SIGNAL_MENTOR_DATA}`, params)
    //       .then((response) => {
    //         const { data, status } = response || {};
    //         if (status === 200) {
    //           const newObject = {
    //             id: data?.data?.id,
    //             name: data?.data?.applicant_name,
    //           };
    //           newNameArray.push(newObject);
    //           setAppArrayMap(newNameArray);
    //           setFormData((user) => {
    //             return { ...user, enrolementIdsnew: newNameArray };
    //           });
    //         } else {
    //           // return { status: false }
    //         }
    //       })
    //       .catch((e) => {
    //         // return Promise.reject(e);
    //       });
    //   });

    setStudents(value);
  }, [applicationData]);

  // useEffect(() => {
  //   applicationData &&
  //     applicationData?.data?.mentorenrolmentid.map((item) => {
  //       const params = {
  //         email_id: item,
  //       };
  //       api
  //         .POST(`${GET_SIGNAL_MENTOR_DATA}`, params)
  //         .then((response) => {
  //           const { data, status } = response || {};
  //           if (status === 200) {
  //

  //             const newObject = {
  //               id: data?.data?.id,
  //               name: data?.data?.applicant_name,
  //             };
  //             newNameArray.push(newObject);
  //             setAppArrayMap(newNameArray);
  //           } else {
  //             // return { status: false }
  //           }
  //         })
  //         .catch((e) => {
  //           // return Promise.reject(e);
  //         });
  //     });
  // }, []);

  const getMentorNames = () => {
    applicationData &&
      applicationData?.data?.mentorenrolmentid.map((item) => {
        const params = {
          email_id: item,
        };
        api
          .POST(`${GET_SIGNAL_MENTOR_DATA}`, params)
          .then((response) => {
            const { data, status } = response || {};
            if (status === 200) {
              const newObject = {
                id: data?.data?.id,
                name: data?.data?.applicant_name,
              };
              newNameArray.push(newObject);
              setAppArrayMap(newNameArray);
            } else {
              // return { status: false }
            }
          })
          .catch((e) => {
            // return Promise.reject(e);
          });
      });
    newNameArray?.map((item, index) => {
      return (
        <div
          key={index}
          style={{
            fontWeight: 700,
            color: "rgb(58, 194, 215)",
          }}
          className="newuserTooltip"
        >
          <a
            className="newclickopenprofile"
            style={{
              cursor: "pointer",
            }}
            href="JavaScript:void(0)"
            onClick={() => {
              ViewProfile(item?.id);
            }}
          >
            {/* {item} */}
            {"M" + item?.id.slice(item?.id.length - 6) + " " + item?.name}
          </a>
          <span
            className="tooltiptext tooltip-bottom"
            style={{
              width: "150px",
              top: "32px",
              paddingTop: "4px",
              left: "3%",
            }}
          >
            View Mentor Profile
          </span>
        </div>
      );
    });
  };

  const ViewProfile = (item) => {
    const currentRoute = window.location.href;
    let sample;
    sample = currentRoute.slice(0, currentRoute.lastIndexOf("/"));
    let reRoute = window.open(`/mentor-profile/${encryptAES2(item,PROFILE_KEY)}`, "_blank");
    // let reRoute = window.open(`/mentor-profile/${item}`, "_blank");
    reRoute.id = item;
  };
  const renderTableData = () => {
    return students?.map((student, index) => {
      const { id, question, answser } = student;
      return (
       (  
        (question == "Startup Application End Date" || question == "Startup Application Start Date" || question ==  "Cohort Start Date") 
        ?
         (applicationData?.data?.applicationStatus != "DRAFT" &&  applicationData?.data?.applicationStatus != "REQUESTINFO"  && applicationData?.data?.applicationStatus !=  "SUBMITTED" ) : true) &&
        <tr key={id}>
          <td className="question_name">
            <p>{question}</p>
          </td>
          <td className="anwsers">
            {question === "Industry / Sector" ||
            question === "Preferred stage of the startup" ||
            question === "Specialization / Function" ? (
              answser?.map((item, index) => <p key={index}>{item}</p>)
            ) : question === "Mentor Enrolment IDs" ? (
              answser?.map((item, index) => {
                return (
                  <div
                    key={index}
                    style={{
                      fontWeight: 700,
                      color: "rgb(58, 194, 215)",
                    }}
                    className="newuserTooltip"
                  >
                    <a
                      className="newclickopenprofile"
                      style={{
                        cursor: "pointer",
                      }}
                      href="JavaScript:void(0)"
                      onClick={() => {
                        ViewProfile(item);
                      }}
                    >
                      {"M" +
                        item.slice(item.length - 6) +
                        " "}
                        {/* // `(${item?.name})`} */}
                    </a>
                    <span
                      className="tooltiptext tooltip-bottom"
                      style={{
                        width: "150px",
                        top: "32px",
                        paddingTop: "4px",
                        left: "3%",
                      }}
                    >
                      View Mentor Profile
                    </span>
                  </div>
                );
              //   () => {
              //     getMentorNames();
              //   }
              // ) :
              // answser?.map((item, index) => {
              //   return (
              //     <div
              //       key={index}
              //       style={{
              //         fontWeight: 700,
              //         color: "rgb(58, 194, 215)",
              //       }}
              //       className="newuserTooltip"
              //     >
              //       <a
              //         className="newclickopenprofile"
              //         style={{
              //           cursor: "pointer",
              //         }}
              //         href="JavaScript:void(0)"
              //         onClick={() => {
              //           ViewProfile(item?.id);
              //         }}
              //       >
              //         {"M" +
              //           item?.id.slice(item?.id.length - 6) +
              //           " " +
              //           `(${item?.name})`}
              //       </a>
              //       <span
              //         className="tooltiptext tooltip-bottom"
              //         style={{
              //           width: "150px",
              //           top: "32px",
              //           paddingTop: "4px",
              //           left: "3%",
              //         }}
              //       >
              //         View Mentor Profile
              //       </span>
              //     </div>
              //   );
              })
            ) : question === "Banner" ? (
              answser && (
                <a
                  href={answser}
                  target="_blank"
                  style={{ fontWeight: 700, color: "#3AC2D7" }}
                >
                  {"View Banner"}
                </a>
              )
            ) : question === "Upload List of Mentors" ? (
              answser && (
                <a
                  href={answser}
                  target="_blank"
                  style={{ fontWeight: 700, color: "#3AC2D7" }}
                >
                  {"View List of Mentors"}
                </a>
              )
            ) : 
             
            
            (
              <p>{answser}</p>
            )}
          </td>
        </tr>
      );
    });
  };

  //   };

  const setAdminCohortAppStatus = (action, id, status) => {
    let params = {
      id: id,
      status: "VERIFIED",
      comments: " ",
    };
    // let params = {
    //   id: id,
    //   status: status,

    // };
    api
      .POST(`${SET_ADMIN_COHORT_STATUS}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          // localStorage.setItem("mentorMenu", "mentorMenu");

          let text = "Application Accepted Successfully";
          swal("Success", text, "success", { closeOnClickOutside: false }).then(
            function () {
              window.close();
            }
          );
          // history.goBack();
        } else {
          // return { status: false }
        }
      })
      .catch((e) => {
        // return Promise.reject(e);
      });
  };

  return (
    <div className="ViewApplication-StartupData pt-5 cohortapplication-view">
      <div className="col-md-10 ViewApplication-detailwhole">
        <div>
          <div className="session-detailHeading">
            <p className="display-heading">
              APPLICATION ID :{" "}
              {applicationData &&
                applicationData?.data?.id &&
                getApplicationId(applicationData?.data?.id)}
            </p>
            {applicationData?.data?.uploadLogo == null ? (
              <img src={hashImage} />
            ) : (
              <div style={{ display: "flex" }}>
                {applicationData && (
                  <>
                    <img
                      className="mentor-img"
                      style={{ marginLeft: "20px" }}
                      src={
                        applicationData?.data?.uploadLogo !== null
                          ? applicationData?.data?.uploadLogo
                          : hashImage
                      }
                    />
                  </>
                )}
              </div>
            )}
          </div>
        </div>

        <table id="session">
          <tbody>{renderTableData()}</tbody>
        </table>
        {value &&
        value?.role === "Admin" &&
        applicationData?.data?.applicationStatus === "SUBMITTED" ? (
          <>
            <div>
              <a
                onClick={() => {
                  setSelectedColor(true);
                  setSelectedColor2(false);
                  setSelectedColor3(false);
                  setAdminCohortAppStatus("Approve", window.id, "VERIFIED");
                }}
                className="brd-btn d-inline-block newbtnbottom"
                style={{
                  backgroundColor: "#f4f4f4",
                  color: selectedColor === true ? "#fff" : "#3AC2D7",
                  width: "10.5em",
                  marginTop: "20px",
                  marginRight: "8px",
                  border:
                    selectedColor === true ? "0px" : "1px solid #00000040",
                  borderRadius: "5px",
                  paddingTop: "6px",
                  paddingBottom: "6px",
                  cursor: "pointer",
                }}
                title=""
              >
                APPROVE
              </a>

              <a
                onClick={() => {
                  setSelectedColor2(true);
                  setSelectedColor(false);
                  setSelectedColor3(false);
                  onclickShowSubmitAction("Approve", window.id, "REJECTED");
                }}
                className="brd-btn d-inline-block newbtnbottom"
                style={{
                  backgroundColor: "#f4f4f4",
                  // backgroundColor: "#f4f4f4",
                  color: selectedColor === true ? "#fff" : "#3AC2D7",
                  // color: "#3AC2D7",
                  width: "10.5em",
                  marginTop: "20px",
                  marginRight: "8px",
                  border:
                    selectedColor === true ? "0px" : "1px solid #00000040",
                  borderRadius: "5px",
                  paddingTop: "6px",
                  paddingBottom: "6px",
                }}
                href="javascript:void(0)"
                title=""
              >
                REJECT
              </a>

              <a
                onClick={() => {
                  setSelectedColor3(true);
                  setSelectedColor(false);
                  setSelectedColor2(false);
                  onclickShowSubmitAction("Approve", window.id, "REQUESTINFO");
                }}
                className="brd-btn d-inline-block newbtnbottom"
                style={{
                  backgroundColor: "#f4f4f4",
                  color: selectedColor === true ? "#fff" : "#3AC2D7",
                  width: "10.5em",
                  marginTop: "20px",
                  marginRight: "8px",
                  border:
                    selectedColor === true ? "0px" : "1px solid #00000040",
                  borderRadius: "5px",
                  paddingTop: "6px",
                  paddingBottom: "6px",
                }}
                href="javascript:void(0)"
                title=""
              >
                REQUEST INFO
              </a>
            </div>
          </>
        ) : (
          ""
        )}
        {/* {applicationData?.data?.applicationStatus === "SUBMITTED" ? <>
        <div>
              <a
                onClick={() => {
                  setSelectedColor(true);
                  setSelectedColor2(false);
                  setSelectedColor3(false);
                  setAdminCohortAppStatus(
                    "Approve",
                    window.id,
                    "VERIFIED"
                  );
                }}
                className="brd-btn d-inline-block newbtnbottom"
                style={{
                  backgroundColor: "#f4f4f4",
                  color: selectedColor === true ? "#fff" : "#3AC2D7",
                  width: "10.5em",
                  marginTop: "20px",
                  marginRight: "8px",
                  border:
                    selectedColor === true ? "0px" : "1px solid #00000040",
                  borderRadius: "5px",
                  paddingTop: "6px",
                  paddingBottom: "6px",
                  cursor: "pointer",
                }}
                title=""
              >
                APPROVE
              </a>
           
              <a
                onClick={() => {
                  setSelectedColor2(true);
                  setSelectedColor(false);
                  setSelectedColor3(false);
                  onclickShowSubmitAction(
                    "Approve",
                    window.id,
                    "REJECTED"
                  );
                }}
                className="brd-btn d-inline-block newbtnbottom"
                style={{
                  backgroundColor: "#f4f4f4",
                  // backgroundColor: "#f4f4f4",
                  color: selectedColor === true ? "#fff" : "#3AC2D7",
                  // color: "#3AC2D7",
                  width: "10.5em",
                  marginTop: "20px",
                  marginRight: "8px",
                  border:
                    selectedColor === true ? "0px" : "1px solid #00000040",
                  borderRadius: "5px",
                  paddingTop: "6px",
                  paddingBottom: "6px",
                }}
                href="javascript:void(0)"
                title=""
              >
                REJECT
              </a>
            
              <a
                onClick={() => {
                  setSelectedColor3(true);
                  setSelectedColor(false);
                  setSelectedColor2(false);
                  onclickShowSubmitAction(
                    "Approve",
                    window.id,
                    "REQUESTINFO"
                  );
                }}
                className="brd-btn d-inline-block newbtnbottom"
                style={{
                  backgroundColor: "#f4f4f4",
                  color: selectedColor === true ? "#fff" : "#3AC2D7",
                  width: "10.5em",
                  marginTop: "20px",
                  marginRight: "8px",
                  border:
                    selectedColor === true ? "0px" : "1px solid #00000040",
                  borderRadius: "5px",
                  paddingTop: "6px",
                  paddingBottom: "6px",
                }}
                href="javascript:void(0)"
                title=""
              >
                REQUEST INFO
              </a>
            </div></>:''} */}
      </div>
      <SubmitAction
        isOpen={showSubmitAction}
        className={"form-submit-modal"}
        onClose={clickOnClose}
        action={action}
        submitData={submitData}
        formName={"cohortApp"}
      />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    applicationData: state.AdminMentorViewReducer.getViewApplicationCohort,
  };
};

export default connect(mapStateToProps, {
  getViewApplicationCohort,
})(withRouter(ViewApplicationCohort));
